/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  CreateTaskResponseResponse,
  ForbiddenResponse,
  TaskData,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Create Task API
 */
export const createTask = (taskData: TaskData) => {
  return customInstance<CreateTaskResponseResponse>({
    url: `/bm-declaration-service/v1/task/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: taskData,
  });
};

export const getCreateTaskMutationOptions = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: TaskData },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: TaskData },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, { data: TaskData }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return createTask(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>;
export type CreateTaskMutationBody = TaskData;
export type CreateTaskMutationError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Create Task API
 */
export const useCreateTask = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: TaskData },
    TContext
  >;
}) => {
  const mutationOptions = getCreateTaskMutationOptions(options);

  return useMutation(mutationOptions);
};
